module.exports = __webpack_public_path__ + "img/picking.bfb790a5.svg";